import styled from 'styled-components';

export const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 70px repeat(7, 1fr);
	grid-template-rows: 70px repeat(4, 30px);
	gap: 5px;

	overflow: hidden;
	margin-top: 30px;
	@media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
		margin-right: 60px;
		width: 1050px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		margin-right: 10px;
		margin-left: 10px;
		width: 790px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
		margin-right: 10px;
		margin-left: 10px;
		width: 350px;
	}
`;

export const StyledTopLeftButtons = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	grid-column: 1 / 4;
	gap: 2px;
`;

export const StyledTopRightButtons = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	grid-column: 6 / 9;
	gap: 2px;
`;
export const StyledLargeBlock = styled.div`
	grid-column: 1 / 9;
	background-color: #f2f2f2;
	margin-top: 10px;
`;
